import { RichText } from "@wordpress/block-editor";
import { BlockSaveProps } from "@wordpress/blocks";
import React from "react";
import { Element } from "../../components";
import { cn } from "../../utils";
import Separator from "./components/Separator";

const Save: React.ComponentType<BlockSaveProps<any>> = (props) => {
	const {
		attributes: {
			cssID,
			image = {},
			clientId,
			className,
			link,
			enableCaption,
			caption,
			hoverEffect,
			overlay,
			overlayContent,
			overlayContentPosition,
			showHeadingOn,
			maskShape,
			maskSize,
			maskPosition,
			maskRepeat,
			showDescription,
			imageFilter,
			separatorPosition,
			separatorStyle,
			showSeparatorOn,
		},
	} = props;

	const Image = () => {
		const imageHTML = (
			<img
				className={cn({
					[`wp-image-${image?.id}`]: !!image?.id,
					[`hover-effect-${hoverEffect}`]: !!hoverEffect,
					[`filter-${imageFilter}`]: !!imageFilter,
					[`mask mask-${maskShape}`]: !!maskShape,
					[`mask-size-${maskSize}`]:
						maskShape && maskShape !== "none" && maskSize,
					[`mask-position-${maskPosition}`]:
						maskShape && maskShape !== "none" && !!maskPosition,
					[`mask-repeat-${maskRepeat}`]:
						maskShape && maskShape !== "none" && !!maskRepeat,
				})}
				src={image?.url}
				alt={image?.alt ?? ""}
				height={image?.height ?? undefined}
				width={image?.width ?? undefined}
			/>
		);
		return link?.url ? (
			<Element
				tagName="a"
				htmlAttrs={{
					href: link.url,
					target: link?.newTab ? "_blank" : undefined,
					rel: link?.rel ? "noopener" : undefined,
				}}
			>
				{imageHTML}
			</Element>
		) : (
			imageHTML
		);
	};

	return (
		<figure
			id={cssID ?? undefined}
			className={cn(
				`mzb-image mzb-image-${clientId}`,
				overlay ? `overlay` : "",
				className
			)}
		>
			<Image />
			{enableCaption && !overlay && (
				<RichText.Content tagName="figcaption" value={caption} />
			)}
			{overlay && (
				<div
					className={cn(
						`overlay-content ${overlayContentPosition}`,
						`show-heading-${showHeadingOn}`,
						`show-description-${showDescription}`
					)}
				>
					{separatorPosition === "before-title" && (
						<Separator
							style={separatorStyle}
							showOn={showSeparatorOn}
						/>
					)}
					<RichText.Content tagName="h2" value={overlayContent} />
					{separatorPosition === "after-title" && (
						<Separator
							style={separatorStyle}
							showOn={showSeparatorOn}
						/>
					)}
					<RichText.Content tagName="figcaption" value={caption} />
					{separatorPosition === "after-sub-title" && (
						<Separator
							style={separatorStyle}
							showOn={showSeparatorOn}
						/>
					)}
				</div>
			)}
		</figure>
	);
};

export default Save;
